import request, { Request } from "@/plugin/axios";
import api from "@/constant/api/sso";

const jsonOptions = {
  headers: {
    "Content-Type": "application/json"
  }
};

export function getToken(params, options) {
  return request[api.getToken.method](api.getToken.url, params, options).then((res) => {
    if (res.success === true) {
      //可以在这对获取的数据进行预处理，再统一返回
      return { code: 200, data: res.data };
    }
    return { code: res.code, data: res.data, message: res.message };
  });
}

export function refreshToken(params) {
  // return request[api.refreshToken.method](api.refreshToken.url, params, options).then((res) => {
  //   if (res.status === 200) {
  //     //可以在这对获取的数据进行预处理，再统一返回
  //     return { code: 200, data: res.data };
  //   }
  //   return { code: 200, data: [] };
  // });
  // const url = "http://apisix-dev.x:19080/api/tacoscloud/tacos-cloud-user/token/refreshToken";
  // api.refreshToken.url
  return Request(api.refreshToken, api.refreshToken.url, params, jsonOptions);
}
